/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Price_Include2_SubInputs */

const es_landing_price_include2_sub = /** @type {(inputs: Landing_Price_Include2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación, calendario y comunicación con tus clientes`)
};

const gl_landing_price_include2_sub = /** @type {(inputs: Landing_Price_Include2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación, calendario e comunicación cos teus clientes`)
};

const en_landing_price_include2_sub = /** @type {(inputs: Landing_Price_Include2_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing, calendar and guest communication`)
};

/**
* | output |
* | --- |
* | "Listing, calendar and guest communication" |
*
* @param {Landing_Price_Include2_SubInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const landing_price_include2_sub = /** @type {((inputs?: Landing_Price_Include2_SubInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Price_Include2_SubInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_landing_price_include2_sub(inputs)
	if (locale === "en") return en_landing_price_include2_sub(inputs)
	return es_landing_price_include2_sub(inputs)
});